import ImageFileHelper from '@/lib/image-file-helper';

const imageFileHelper = new ImageFileHelper();
let bordSequenceId = 0;

export default {
  async addBoard({commit, state, rootState, dispatch}, board = {}) {
    let name = board.name;
    let blob = board.blob;
    let id = ++bordSequenceId + '';
    if (!name) {
      name = 'whiteboard-' + id;
    }

    if (!blob) {
      commit('addBoard', {id, name});
      return id;
    }

    let thumbnailBlob = await imageFileHelper.getThumbBlob(blob, {
      maxWidth: 200,
      maxHeight: 200,
      quality: 1
    });

    commit('addBoard', {
      id,
      name,
      url: URL.createObjectURL(blob),
      thumbnailUrl: URL.createObjectURL(thumbnailBlob)
    });
    return id;
  },

  addBoardsByFiles({commit, state, rootState, dispatch}, files) {
    files = [].concat(files);
    files.forEach(file => {
      dispatch('addBoard', {blob: file, name: file.name});
    });
  },

  removeBoard({commit, state, rootState, dispatch}, id) {
    let board = state.boards.find(b => b.id === id);
    if (!board) {
      return;
    }
    URL.revokeObjectURL(board.url);
    URL.revokeObjectURL(board.thumbnailUrl);
    commit('removeBoard', id);
  }
};
